import { render } from "./ValueDisplay.vue?vue&type=template&id=5849f17f"
import script from "./ValueDisplay.vue?vue&type=script&lang=js"
export * from "./ValueDisplay.vue?vue&type=script&lang=js"
script.render = render

export default script